import React from 'react'
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import topImg from "./../../assets/projects/website-hosting-concept-with-circuits 1.png"

import project1 from './../../assets/projects/project1.png'
import project2 from './../../assets/projects/project2.png'
import project3 from './../../assets/projects/project3.png'
import project4 from './../../assets/projects/project4.png'
import project5 from './../../assets/projects/project5.png'
import project6 from './../../assets/projects/project6.png'




import { FiExternalLink } from 'react-icons/fi'
const Projects = () => {
    const projects = [
        {
            id: 1,
            image: project1,
            url: "/"
        },
        {
            id: 2,
            image: project2,
            url: "/"
        },
        {
            id: 3,
            image: project3,
            url: "/"
        },
        {
            id: 4,
            image: project4,
            url: "/"
        },
        {
            id: 5,
            image: project5,
            url: "/"
        },
        {
            id: 6,
            image: project6,
            url: "/"
        }
    ]
    return (
        <div>
            <div className="section_1 min-h-[50vh] bg-cover bg-no-repeat" style={{ backgroundImage: `url("${topImg}")` }}>
                <div className="layer bg-gradient-to-r min-h-[50vh] from-dark to-transparent flex items-center justify-content ">
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="what-we-do col-span-3 lg:col-span-1 m-auto  w-5/6 lg:w-4/6">
                        <span className="bg-dark-navy bg-opacity-50 text-white p-1 px-2 border-l-4 border-l-gold text-sm ">Gallery</span>
                        <h2 className="text-3xl md:text-6xl text-white font-semibold my-3">Our Projects</h2>
                    </motion.div>
                </div>
            </div>
            <div className="section_6 blog py-20">
                <div className="content w-5/6 lg:w-4/6 m-auto flex flex-col items-center">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 py-5">
                        {projects?.map(project => (
                            <div key={project.id} className="col-span-1">
                                <div key={project.id} className="image_box relative flex justify-center items-center group">
                                    <img src={project.image} alt="" className="h-full w-full" />
                                    <Link to={project.url} className="layer group-hover:opacity-70 group-hover:w-full group-hover:h-full duration-300  opacity-0 h-0 w-0 bg-main-light absolute text-white text-sm font-Krub font-semibold flex justify-center items-center">
                                        <FiExternalLink size={20} />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Projects